import { createSlice } from "@reduxjs/toolkit";
import { getListDataGift } from "../../api/giftExchange/dataGift";

const initialState = {
  listDataGifts: [],
  isLoadDataGift: false,
  currentPage: 1,
  pageSize: 10,
  error: null,
  totalRecords: 0,
};

const dataGiftSlice = createSlice({
  name: "dataGift",
  initialState,
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    },
    setTotalRecords: (state, action) => {
      state.totalRecords = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getListDataGift.pending, (state) => {
        state.isLoaddataGift = true;
        state.error = null;
      })
      .addCase(getListDataGift.fulfilled, (state, action) => {
        state.isLoadDataGift = false;
        state.listDataGifts = action.payload.data || [];
        state.currentPage = action.payload.current_page;
        state.pageSize = action.payload.per_page;
        state.totalRecords = action.payload.total;
      })
      .addCase(getListDataGift.rejected, (state, action) => {
        state.isLoaddataGift = false;
        state.error = action.payload;
      });
  },
});

export const { setCurrentPage, setPageSize, setTotalRecords } = dataGiftSlice.actions;
export default dataGiftSlice.reducer;
